<template>
  <div class="loginForm modal fade" id="dashboardModal">
    <row class="modal-dialog" role="document" style="width: 100%">
      <column class="col-md-3"></column>
      <column class="col-md-6" style="width: 750px;">
        <va-box name="boxInstaller" :title="title" theme="box-info" :isBorder="true" widgetType="">
          <div slot="content">
            <form class="form-horizontal" style="background-color: white; padding-left: 10px;">

              <div class="form-group">
                <H3 class="col-sm-12" style="margin-left: 10px;"> Download Printer Counters Client Installer</H3>
              </div>

              <div class="form-group">
                <div class="col-sm-12" style="margin-left: 10px;">
                  <p>To start monitoring USB and/or Network printers</p>
                  <p>To Collect printers counters automatically & schedule reports</p>
                  <p>Click to download :</p>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12">

                  <downloadBtn style="width: 300px; text-align: center;"
                               :title="btnLAN.title"
                               :img="btnLAN.img"
                               :info="btnLAN.info"
                               :icon="btnLAN.icon"
                               :btnText="btnLAN.btnText"
                               @click="downloadLAN()">
                  </downloadBtn>

                  <downloadBtn style="width: 300px;"
                               :title="btnUSB.title"
                               :img="btnUSB.img"
                               :info="btnUSB.info"
                               :icon="btnUSB.icon"
                               :btnText="btnUSB.btnText"
                               @click="downloadUSB()">
                  </downloadBtn>

                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-12" style="padding: 20px; text-align: right;">
                  <input type="button" class="btn btn-danger" value="I will download later" style="margin-top: 20px;" @click="downloadLater()" />
                </div>
              </div>
            </form>
          </div>
        </va-box>
      </column>
      <column class="col-md-3"></column>
    </row>
  </div>
</template>
<script>
  import downloadBtn from './Home/downloadBtn'
  import VABox from '../widgets/VABox.vue'

  export default {
    name: 'DownloadInstaller',
    components: {
      downloadBtn,
      'va-box': VABox
    },
    data () {
      return {
        dealerKey: '',
        customerKey: '',
        siteKey: '',
        title: 'Download Printer Counters Installer',
        name: '',
        address: '',
        totalPrinters: 0,
        error: '',
        btnLAN: {
          title: 'Network Printers',
          img: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAI4AAACOCAYAAADn/TAIAAAACXBIWXMAABcRAAAXEQHKJvM/AAACeUlEQVR4Xu3dsW1bZxiG0U+B9nDGCCsxk0SV1ogyRljJk/iqYusRlA2ygVLIZcCfeGhHtHNO/QIkLh+SAIH78+b19XW+V7vDts3M3Wp3pX49Puy31eha/bQawL8RDolwSIRDIhwS4ZAIh0Q4JMIhEQ6JcEiEQyIcEuGQCIdEOCTCIREOiXBIhEMiHBLhkAiHRDgkN9/zDXlf0+6wnXMh/jg+7B9Xo/8DnzgkwiERDolwSIRDIhwS4ZAIh0Q4JMIhEQ6JcEiEQyIcEuGQCIdEOCTCIREOiXBIhEMiHBLhkAiHRDgkwiERDolwSIRDIhwS4ZAIh0Q4JMIhEQ6JcEiEQyIcEuGQCIfkogOyd4dtPzOfVjuuzvPxYb9fjU7xiUMiHBLhkAiHRDgkwiERDolwSG5Xg6/k48y8rEbv7PfVYGaeZ2Zbjd7Z/cx8WI0u9V+F83R82G+r0XvaHbZzwtmu/a8Vv/ya/83D8VVFIhwS4ZAIh0Q4JMIhEQ6JcEiEQyIcEuGQCIdEOCTCIREOiXBIhEMiHBLhkAiHRDgkwiERDolwSIRDIhwS4ZAIh0Q4JMIhEQ6JcEiEQyIcEuGQCIdEOCTCIREOyc0vf356XI1O+HlmfluN5sIDss85W3h32O7n7flU55xzfOkB2U/Hh/3LqcGXc4r3pzYL97M+5/ivmXlabE55uZ3zLtilzonrlMfVYN4u2N1qdKG7uewxtlm/gfbz7V+TD3PZYzz7qiIRDolwSIRDIhwS4ZAIh0Q4JMIhEQ6JcEiEQyIcEuGQCIdEOCTCIREOiXBIhEMiHBLhkAiH5HbebjL7EXxeDa7A36vBvN13de2vyed/AIymQ7HCJiFzAAAAAElFTkSuQmCC',
          info: 'Collect NETWORK printer counters automatically & schedule reports',
          icon: 'fa fa-download',
          btnText: 'Download Network Client Installer'
        },
        btnUSB: {
          title: 'USB Printers',
          img: 'data:image/png;base64,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',
          info: 'Collect USB printer counters automatically & schedule reports',
          icon: 'fa fa-download',
          btnText: 'Download USB Client Installer'
        }
      }
    },
    created () {
    },
    mounted () {
      this.$bus.$on('dashboardModal-open', (args) => {
        console.log(args)
        $('#dashboardModal').modal('show')
      })
    },
    methods: {
      downloadUSB () {
        var hiddenElement = document.createElement('a')
        hiddenElement.href = this.$root.installerLinks.UsbInstaller
        hiddenElement.target = '_blank'
        hiddenElement.click()
        $('#dashboardModal').modal('hide')
        let vm = this
        let title = 'Usb Client Installer'
        let message = 'Usb Client Installer was downloaded.'
        vm.$root.setAlert(title, message)
      },
      downloadLAN () {
        var hiddenElement = document.createElement('a')
        hiddenElement.href = this.$root.installerLinks.LanInstaller
        hiddenElement.target = '_blank'
        hiddenElement.click()
        $('#dashboardModal').modal('hide')
        let vm = this
        let title = 'Lan Client Installer'
        let message = 'Lan Client Installer was downloaded.'
        vm.$root.setAlert(title, message)
      },
      downloadLater () {
        $('#dashboardModal').modal('hide')
      },
      save () {
        $('#dashboardModal').modal('hide')
      },
      cancel () {
        this.reset()
        $('#dashboardModal').modal('hide')
      },
      isValid () {
        this.error = ''

        if (!this.dealerKey || this.dealerKey.length === 0) {
          this.error = '* Unknown Dealer!'
          return false
        }

        if (!this.customerKey || this.customerKey.length === 0) {
          this.error = '* Please Select a Customer!'
          return false
        }

        if (!this.name || this.name.length === 0) {
          this.error = '* Please enter your Site Name!'
          return false
        }

        if (!this.address || this.address.length === 0) {
          this.error = '* Please enter your Site Addresse!'
          return false
        }

        return true
      },
      reset () {
        this.name = ''
        this.address = ''
        this.siteKey = ''
        this.dealerKey = ''
        this.customerKey = ''
        this.totalPrinters = 0
        this.error = ''
      }
    }
  }

</script>



// WEBPACK FOOTER //
// DownloadInstaller.vue?32249836